export default "__VITE_ASSET__DDhufSM4__"